import { render, staticRenderFns } from "./action-select.vue?vue&type=template&id=effa87bc&"
import script from "./action-select.vue?vue&type=script&lang=js&"
export * from "./action-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports